import script from "./xianxiazuoye.vue?vue&type=script&setup=true&lang=js"
export * from "./xianxiazuoye.vue?vue&type=script&setup=true&lang=js"

import "./xianxiazuoye.vue?vue&type=style&index=0&id=3dc70e28&lang=less&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3dc70e28"]])

export default __exports__